import React, { CSSProperties } from 'react';
import './Loader.css';
import '../styles/styles.css'

interface LoaderProps {
  color?: string;
}

const Loader: React.FC<LoaderProps> = ({ color = 'icon' }) => {

  const dotInnerStyle: CSSProperties = {
    backgroundColor: `rgb(var(${color}))`
  };

  return (
    <div className="loader">
      <div className='dot'><div className='dot-inner' style={dotInnerStyle} /></div>
      <div className='dot'><div className='dot-inner' style={dotInnerStyle} /></div>
      <div className='dot'><div className='dot-inner' style={dotInnerStyle} /></div>
      <div className='dot'><div className='dot-inner' style={dotInnerStyle} /></div>
      <div className='dot'><div className='dot-inner' style={dotInnerStyle} /></div>
    </div>
  );
};

export { Loader };  // If you'd like to use named exports, replace this with: export const Loader = ...
